/** @jsx jsx */

import { jsx } from '@emotion/core';
import { kebabCase } from 'lodash';
import { useState } from 'react';

import { useStaticAssetPath } from '@zapier/common-components';

const imageCss = (isSmall: boolean) => ({
  display: 'inline-block',
  width: isSmall ? 50 : 60,
});

const svgCss = (props: PaymentMethodImageProps) => ({
  display: 'block',
  height: 'inherit',
  opacity: props.isDisabled ? 0.4 : 1.0,
  width: 'inherit',
});

type PaymentMethodImageProps = {
  /** Image type to show */
  imageType: string;
  /** Show image greyed out */
  isDisabled?: boolean;
  /** Show small version of image */
  isSmall?: boolean;
};

const PaymentMethodImage = (props: PaymentMethodImageProps) => {
  const [imageNotFound, setImageNotFound] = useState(false);
  const { imageType, isSmall = false } = props;

  const { buildStaticAssetUrl } = useStaticAssetPath();

  const svgUrl = imageNotFound
    ? buildStaticAssetUrl('/images/payment/unknown.svg')
    : buildStaticAssetUrl(`/images/payment/${kebabCase(imageType)}.svg`);

  return (
    <span css={imageCss(isSmall)}>
      <img
        alt={imageType}
        css={svgCss(props)}
        onError={() => setImageNotFound(true)}
        src={svgUrl}
      />
    </span>
  );
};

export default PaymentMethodImage;
